<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">

    <vx-card >

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab :label="$t('MODULES.moduleCreation')" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <module-edit-tab class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import ModuleEditTab     from './ModuleEditTab.vue'

// Store Module
// import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    ModuleEditTab
  },
  data () {
    return {

    }
  },
  mounted () {
    document.title = `${document.title.split(' | ')[0]  } | Módulos`
  },
  methods: {
    created () {

    }
  }
}

</script>
